
import { bracket as BRKT } from "@packageconfig";

/**
 * Produce the minimum amount, the slippage and the slippage percent when given an amount-in and quote for it in ETH
 * 
 * @param {number} tokIn the amount-in as ethereum and measured in USD 
 * @param {number} tokOut a quote for the input amount as ethereum and measured in USD.
 * @returns {[number, number, nunber]} the minimum amount out, the slippage, and the impact.
 */
export const calcMinAndSlippage = (
	amount_in: number,
	amount_out: number,
):[ number, number, number, ] => {
	const min_amount_out = amount_out * (1-Number(BRKT.slippage));
	const slippage = amount_in - amount_out;
	const impact = (amount_in - amount_out) / amount_out;
	return [
		min_amount_out,
		slippage,
		impact,
	];

}
